export function renderMarketsColumnsFilter(markets: any[], columns: any): any[] {
    let marketsTrimmed = markets;

    Object.keys(columns).forEach((key) => {
        columns[key] && (marketsTrimmed = markets.slice(0, parseInt(key)));
    });

    return marketsTrimmed;
}
